/* Accesorios PDP overrides JS — extracted + bug-fixed 2026-06-02. See acc-pdp-overrides.css banner. */
(function(){
(function(){
  // Phase 50: block right-click + drag on first product image
  function harden(){
    var guards = document.querySelectorAll('.acx-first-img-guard, .acx-first-img-guard img');
    guards.forEach(function(el){
      if(el.__acxHardened) return;
      el.__acxHardened = true;
      el.setAttribute('draggable', 'false');
      el.addEventListener('contextmenu', function(e){ e.preventDefault(); return false; }, {passive: false});
      el.addEventListener('dragstart', function(e){ e.preventDefault(); return false; }, {passive: false});
      el.addEventListener('selectstart', function(e){ e.preventDefault(); return false; }, {passive: false});
    });
  }
  if(document.readyState !== 'loading'){ harden(); }
  else { document.addEventListener('DOMContentLoaded', harden); }
  // Re-arm after variant re-render
  setTimeout(harden, 800);
  setTimeout(harden, 2500);
  // Canvas-swap for ALL gallery images (Phase 53). On zoom button click, restore img.
  function obscureSrc(){
    var imgs = document.querySelectorAll('.acx-first-img-guard img:not(.product-watermark)');
    imgs.forEach(function(img){
      if(img.__acxObscured) return;
      img.__acxObscured = true;
      // Wait for image to be painted, then move src to data-original-src
      var apply = function(){
        if(!img.src || img.dataset.acxSwapped) return;
        try {
          var canvas = document.createElement('canvas');
          canvas.width = img.naturalWidth || img.offsetWidth;
          canvas.height = img.naturalHeight || img.offsetHeight;
          canvas.style.cssText = img.style.cssText;
          canvas.style.width = '100%';
          canvas.style.height = 'auto';
          canvas.style.maxWidth = '100%';
          canvas.style.aspectRatio = canvas.width + ' / ' + canvas.height;
          canvas.style.display = 'block';
          canvas.style.margin = '0';
          canvas.style.objectFit = 'contain';
          canvas.className = (img.className || '') + ' acx-canvas-swapped';
          var ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          img.parentNode.replaceChild(canvas, img);
        } catch(e) {
          // CORS or other error — leave img as is
        }
      };
      if(img.complete && img.naturalWidth > 0) apply();
      else img.addEventListener('load', apply, {once: true});
    });
  }
  // Don't auto-obscure: breaks zoom integration on OTHER images and may affect SEO crawlers
  // Vinay: enable by adding ?obscure=1 to URL or uncomment next line
  /* Phase 59: canvas-swap disabled — was causing loading-state flashes + swatch hover bugs */
})();



(function(){
  // Strip space after currency symbol on price elements: "₹ 599" -> "₹599"
  function tighten(el){
    if(!el) return;
    el.childNodes.forEach(function(n){
      if(n.nodeType === 3 && n.nodeValue){
        var fixed = n.nodeValue.replace(/(₹|Rs\.?)\s+/g, '$1');
        if(fixed !== n.nodeValue) n.nodeValue = fixed;
      }
    });
  }
  function scan(){
    document.querySelectorAll('sale-price, compare-at-price').forEach(tighten);
  }
  if(document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', scan);
  // Re-tighten on variant change (when product-rerender fires)
  var mo = new MutationObserver(function(){ scan(); });
  function __attachTighten(){ document.querySelectorAll('product-rerender, product-quick-add').forEach(function(r){ if(r.__acxTightenObs) return; r.__acxTightenObs=1; mo.observe(r, {childList: true, subtree: true, characterData: true}); }); }
  if(document.readyState!=='loading') __attachTighten(); else document.addEventListener('DOMContentLoaded', __attachTighten);
  setTimeout(__attachTighten, 1500);
})();



(function(){
  function pct(sale, compare){
    if(!compare || compare <= sale) return 0;
    return Math.round((compare - sale) / compare * 100);
  }
  function parseRupees(t){
    if(!t) return 0;
    var n = parseFloat(String(t).replace(/[^0-9.]/g, ''));
    return isFinite(n) ? n : 0;
  }
  function inject(qa){
    if(!qa) return;
    var sale = qa.querySelector('sale-price');
    var comp = qa.querySelector('compare-at-price');
    if(!sale || !comp) {
      var ex = qa.querySelector('.acx-pqa-savings');
      if(ex) ex.remove();
      return;
    }
    var saleVal = parseRupees(sale.textContent);
    var compVal = parseRupees(comp.textContent);
    if(!saleVal || saleVal <= 0){ var __pqaC = qa.querySelector('.acx-pqa-savings'); if(__pqaC) __pqaC.remove(); return; }
    var p = pct(saleVal, compVal);
    var chip = qa.querySelector('.acx-pqa-savings');
    if(p <= 0){
      if(chip) chip.remove();
      return;
    }
    if(!chip){
      chip = document.createElement('span');
      chip.className = 'acx-pqa-savings';
      // append after compare-at-price (so it sits inline with prices)
      comp.parentNode.insertBefore(chip, comp.nextSibling);
    }
    chip.textContent = p + '% OFF';
  }
  function scanAll(){
    document.querySelectorAll('product-quick-add').forEach(inject);
  }
  // Initial run when DOM ready
  if(document.readyState !== 'loading'){
    scanAll();
  } else {
    document.addEventListener('DOMContentLoaded', scanAll);
  }
  // Observe re-renders (variant changes, sibling product nav)
  var mo = new MutationObserver(function(muts){
    var seen = new Set();
    muts.forEach(function(m){
      var n = m.target;
      while(n && n.nodeType === 1){
        if(n.tagName && n.tagName.toLowerCase() === 'product-quick-add' && !seen.has(n)){
          seen.add(n);
          inject(n);
          break;
        }
        n = n.parentNode;
      }
    });
  });
  function attachToReRenderers(){
    var roots = document.querySelectorAll('product-rerender, product-quick-add');
    roots.forEach(function(r){
      if(r.__acxObserved) return;
      r.__acxObserved = true;
      mo.observe(r, {childList: true, subtree: true});
    });
  }
  attachToReRenderers();
  // Re-attach after a short delay in case re-renderers mount late
  setTimeout(attachToReRenderers, 1000);
  setTimeout(attachToReRenderers, 3000);
})();



(function(){
  // Toggle .acx-header-scrolled on the header section + body when scrolled past 40px
  var TH = 5; // Phase 64: kick in scrolled state almost immediately
  function tick(){
    var on = window.scrollY > TH;
    document.body.classList.toggle('acx-scrolled', on);
    var sec = document.querySelector('.shopify-section--header');
    if(sec) sec.classList.toggle('acx-header-scrolled', on);
  }
  window.addEventListener('scroll', tick, {passive: true});
  tick();
})();



(function(){
  // Phase 61: STRICT RULE — image #1 must NEVER appear in Impact's zoom modal.
  // We monkey-patch each <product-gallery>.openZoom to filter out the first image's slot.
  function patchOpenZoom(){
    var galleries = document.querySelectorAll('product-gallery');
    galleries.forEach(function(g){
      if (g.__acxZoomPatched) return;
      var origOpenZoom = g.openZoom;
      if (typeof origOpenZoom !== 'function') {
        return; // not initialized yet — a later setTimeout pass will retry (flag NOT set)
      }
      g.__acxZoomPatched = true;
      g.openZoom = function(index){
        // Build filtered dataSource: skip any slide that contains .acx-first-img-guard
        var slides = Array.from(g.querySelectorAll('.product-gallery__media[data-media-type="image"]:not([hidden])'));
        var filtered = [], skippedBeforeIndex = 0;
        slides.forEach(function(slide, i){
          if (slide.querySelector('.acx-first-img-guard') !== null) {
            if (i <= index) skippedBeforeIndex++;
            return; // skip image #1
          }
          var img = slide.querySelector('img:not(.product-watermark)');
          if (!img) return;
          filtered.push({
            thumbnailElement: img,
            src: img.src,
            srcset: img.srcset,
            msrc: img.currentSrc || img.src,
            width: parseInt(img.getAttribute('width')),
            height: parseInt(img.getAttribute('height')),
            alt: img.alt,
            thumbCropped: true
          });
        });
        if (filtered.length === 0) return;
        var newIndex = Math.max(0, index - skippedBeforeIndex);
        if (newIndex >= filtered.length) newIndex = 0;
        try {
          g.photoswipe.loadAndOpen(newIndex, filtered);
        } catch(e) {
          // PhotoSwipe might not be ready — fall back to original (which excludes image #1 naturally via > img selector)
          if (origOpenZoom) origOpenZoom.call(g, index);
        }
      };
    });
  }
  if (document.readyState !== 'loading') patchOpenZoom();
  else document.addEventListener('DOMContentLoaded', patchOpenZoom);
  // Re-patch after late hydration / variant re-render
  setTimeout(patchOpenZoom, 800);
  setTimeout(patchOpenZoom, 2500);
})();
})();
